import React from 'react';
export function CostPerspective() {
  return <section className="py-20 md:py-28 px-4 bg-dark-primary" data-id="element-213">
      <div className="max-w-content mx-auto" data-id="element-214">
        <h2 className="font-serif text-3xl md:text-4xl text-cream leading-tight mb-10 text-center md:text-left max-w-2xl" data-id="element-215">
          Una perspectiva que nadie te da en el consultorio
        </h2>

        <div className="space-y-6 font-sans text-gray-warm text-[17px] md:text-[18px] leading-relaxed" data-id="element-216">
          <p data-id="element-217">
            En Estados Unidos, una consulta con un cardiólogo puede estar entre
            $300 y $400 por visita. Los especialistas pueden superar los
            $150,000 en hospitalización por complicaciones al año. Estas cifras
            no son una póliza de seguro médico. Pero sí son algo que ninguna
            póliza cubre: lo que se acumula dentro de un diagnóstico que aparece
            en un reporte de laboratorio.
          </p>
          <p data-id="element-218">
            El conocimiento inteligente que puedes tener en tu salud no se mide
            en costos de consultas ni en la calidad de las decisiones que tomas
            cada día con información suficiente para elegir bien.
          </p>
        </div>
      </div>
    </section>;
}